// TES-1291 (TES-1267 §4) — the sections every treatment decision is made in,
// in A-02/09C §4's order:
//   "Flödet visar: 1) aktuell behandling och nytt patientunderlag,
//    2) strukturerat utfall, 3) strukturerad Recept/MedicationPlan,
//    4) Läkarens kommentar till behandlingsbeslutet, 5) relevanta
//    Webdoc-bekräftelser, 6) förhandsvisning och aktiv publicering."
// One list, so the monthly review and the decision workspace number and name
// their steps the same way.
export const DECISION_SECTIONS = [
  "current",
  "outcome",
  "recept",
  "comment",
  "webdoc",
  "preview",
] as const;
export type DecisionSectionKey = (typeof DECISION_SECTIONS)[number];

export const DECISION_SECTION_TITLE: Record<DecisionSectionKey, string> = {
  current: "Aktuell behandling och nytt patientunderlag",
  outcome: "Strukturerat utfall",
  recept: "Recept",
  comment: "Läkarens kommentar till behandlingsbeslutet",
  webdoc: "Webdoc-bekräftelser",
  preview: "Förhandsvisning och publicering",
};

/** "1. Aktuell behandling …": the section's number is its place in A-02's list. */
export function decisionSectionHeading(key: DecisionSectionKey): string {
  return `${DECISION_SECTIONS.indexOf(key) + 1}. ${DECISION_SECTION_TITLE[key]}`;
}
